<template>
  <BCheckbox :value="value" :native-value="subcategory.groupId" @input="$emit('input', $event)">
    {{ getName(subcategory) }}
  </BCheckbox>
</template>

<script>
import { subcategoryGroupsNames } from '@/data/meda-player/advanced-filter-categories';
export default {
  name: 'MediaPlayerSubcategoryCheckbox',
  components: {
    BCheckbox: async () => {
      const { BCheckbox } = await import('buefy/dist/esm/checkbox');
      return BCheckbox;
    },
  },
  props: {
    subcategory: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    'subcategory.isSelected'(newValue) {
      if (newValue) {
        // todo: select child categories
        if (!this.value.includes(this.subcategory.groupId)) {
          this.$emit('input', [...this.value, this.subcategory.groupId]);
        }
        if (
          newValue &&
          this.subcategory.fatherCategories.every(
            fatherCategory => fatherCategory.level !== 0 && !fatherCategory.isSelected,
          )
        ) {
          this.subcategory.fatherCategories[0].isSelected = true;
        }
      }
    },
    'subcategory.fatherCategories': {
      deep: true,
      handler(newValue) {
        if (newValue.every(fatherCategory => fatherCategory.level !== 0 && !fatherCategory.isSelected)) {
          this.subcategory.isSelected = false;
          this.$emit(
            'input',
            this.value.filter(subcategoryGroupId => subcategoryGroupId !== this.subcategory.groupId),
          );
        }
      },
    },
  },
  methods: {
    getName(subcategory) {
      return subcategoryGroupsNames[subcategory.groupId] || subcategory.name;
    },
    // onChange($event) {
    //   this.subcategory.isSelected = $event.target.checked;
    //   if (
    //     this.subcategory.isSelected &&
    //     this.subcategory.fatherCategories.every(
    //       fatherCategory => fatherCategory.level !== 0 && !fatherCategory.isSelected,
    //     )
    //   ) {
    //     this.subcategory.fatherCategories[0].isSelected = true;
    //   }
    // },
  },
};
</script>

<style scoped lang="scss"></style>
